import { faFileExcel, faFileImport, faSearch, faSitemap } from "@fortawesome/pro-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { FormControl, MobileStepper, Stepper, Table } from "@mui/material"
import { styled } from "@mui/material/styles"
import theme from "css/theme/light"

export const StyledDiv = styled("div")(({ active, completed }) => {
  let style = {
    backgroundColor: theme.palette.grey[300],
    zIndex: 1,
    color: theme.palette.foreground.inverted,
    width: 50,
    height: 50,
    display: "flex",
    borderRadius: "50%",
    justifyContent: "center",
    alignItems: "center"
  }
  if (completed) {
    style = Object.assign({}, style, {
      backgroundImage: "linear-gradient(136deg, rgb(109,199,220) 0%, rgb(0,152,184) 50%, rgb(46,53,71) 100%)"
    })
  } else if (active) {
    style = Object.assign({}, style, {
      backgroundImage: "linear-gradient(136deg, rgb(109,199,220) 0%, rgb(0,152,184) 50%, rgb(46,53,71) 100%)",
      boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)"
    })
  }

  return style
})

export function StepIcon(props) {
  const { active, completed, icon } = props

  const icons = {
    1: <FontAwesomeIcon icon={faFileExcel} />,
    2: <FontAwesomeIcon icon={faSitemap} />,
    3: <FontAwesomeIcon icon={faSearch} />,
    4: <FontAwesomeIcon icon={faFileImport} />
  }

  return (
    <StyledDiv active={active} completed={completed}>
      {icons[String(icon)]}
    </StyledDiv>
  )
}
export const StyledStepper = styled(Stepper)({
  background: "transparent",
  "& .MuiStepConnector-alternativeLabel": {
    top: "25px",
    left: "calc(-50% + 35px)",
    right: "calc(50% + 35px)"
  }
})

export const StyledMobileStepper = styled(MobileStepper)(({ theme }) => ({
  maxWidth: "calc(100% - 11px)",
  flexGrow: 1,
  bottom: "0",
  position: "fixed",
  width: "100%",
  background: theme.palette.background.dark,
  color: theme.palette.background.paper,
  boxShadow: "0px 0px 65px 0px rgb(0 0 0 / 6%)",
  [theme.breakpoints.up("sm")]: {
    maxWidth: "calc(100% - 240px)"
  },
  [theme.breakpoints.down("lg")]: {
    "& .MuiLinearProgress-root": {
      display: "none"
    }
  }
}))

export const StyledWideFormControl = styled(FormControl)({
  minWidth: 250
})

export const StyledImportTable = styled(Table)(({ theme }) => ({
  marginBottom: "52px",
  overflowX: "auto",
  "& .MuiTableCell-sizeSmall": {
    padding: "6px 8px 6px 8px",
    "&.locked": {
      background: theme.palette.grey[300],
      borderBottomColor: "rgb(169, 169, 169)"
    },
    "& .MuiFormControl-root": {
      margin: 0,
      "& .MuiSelect-select": {
        fontSize: "14px"
      },
      "& .MuiFormLabel-root": {
        fontSize: "14px"
      }
    }
  },
  "& .MuiTableCell-sizeSmall:first-of-type": {
    paddingLeft: "24px"
  },
  "& .MuiFormControl-root": {
    minWidth: "90px"
  },
  "& .MuiTableRow-root": {
    verticalAlign: "bottom"
  },
  "& .MuiTableCell-head": {
    background: "rgba(239, 239, 239, 1)"
  },
  "& .MuiTypography-caption": {
    flex: 1,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis"
  }
}))
